import React, { useState, useEffect } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../locale/messages';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import SideMenuSection from './SideMenuSection';
import history from '../../history';
import {
  getDashboardSideMenu,
  getConfigurationSideMenu,
  getAdminUserSideMenu,
  getUserSideMenu,
  getOpConfiguration,
  getJobsSideMenu,
  payoutSideMenu,
  monitorSideMenu,
  announcementSideMenu,
  contentSideMenu
} from '../../helpers/getSideMenuData';
import s from './SideMenu.css';

const SideMenu = (props) => {
  const {
    isSuperAdmin = false,
    privileges = [],
    location: propLocation,
    intl,
    handleMobileMenu
  } = props;

  const [location, setLocation] = useState('');

  useEffect(() => {
    setLocation(history.location.pathname);
  }, []);

  useEffect(() => {
    if (propLocation !== location) {
      setLocation(propLocation);
    }
  }, [propLocation]);

  const sideMenu = [
    { menuData: getDashboardSideMenu, label: '' },
    { menuData: getConfigurationSideMenu, label: intl?.formatMessage(messages.configurationsSideMenu) },
    { menuData: getAdminUserSideMenu, label: intl?.formatMessage(messages.adminConfiguration) },
    { menuData: getUserSideMenu, label: intl?.formatMessage(messages.usersSidemenu) },
    { menuData: getOpConfiguration, label: intl?.formatMessage(messages.opConfigurationSideMenu) },
    { menuData: getJobsSideMenu, label: intl?.formatMessage(messages.jobSideMenu) },
    { menuData: payoutSideMenu, label: intl?.formatMessage(messages.payoutSidemenu) },
    { menuData: monitorSideMenu, label: intl?.formatMessage(messages.monitorSidemenu) },
    { menuData: announcementSideMenu, label: intl?.formatMessage(messages.announcementSideMenu) },
    { menuData: contentSideMenu, label: intl?.formatMessage(messages.contentPageSideMenu) }
  ];

  return (
    <div className={s.sideMenuContent}>
      <div className={s.sideMenuHeader}>
        <FormattedMessage {...messages.siteAdmin} />
      </div>
      <div className={s.sideMenuBody}>
        {sideMenu.map((item, key) => {
          return (
            <SideMenuSection
              menuData={item?.menuData}
              label={item?.label}
              location={location}
              privileges={privileges}
              isSuperAdmin={isSuperAdmin}
              handleMobileMenu={handleMobileMenu}
              key={key}
            />
          )
        })}
      </div>
    </div>
  );
};

const mapState = state => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
  privileges: state.account && state.account.privileges,
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch)
)(SideMenu);